export default "__VITE_ASSET__CWW1Kzp8__"